import { render, staticRenderFns } from "./Qi.vue?vue&type=template&id=4aba5098&scoped=true&"
import script from "./Qi.vue?vue&type=script&lang=js&"
export * from "./Qi.vue?vue&type=script&lang=js&"
import style0 from "./Qi.vue?vue&type=style&index=0&id=4aba5098&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aba5098",
  null
  
)

export default component.exports